import { useAppContext } from '@hooks/use-app-context.ts'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

export function useRedirectToStepper() {
	const { state } = useAppContext()
	const navigation = useNavigate()

	useEffect(() => {
		if (state.data.IdRichiesta === 0) {
			navigation('/')
		}
	}, [])
}
